import { render, staticRenderFns } from "./FormProductMapper.vue?vue&type=template&id=52b7a646"
import script from "./FormProductMapper.vue?vue&type=script&lang=js"
export * from "./FormProductMapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports